import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { StudentGuardiansDTO } from 'src/app/models/studentGuardianDto';
import { authData } from 'src/app/util/auth';
import { errorHandler } from 'src/app/util/errorHandler';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-application-family-create',
  templateUrl: './application-family-create.component.html',
  styleUrls: ['./application-family-create.component.scss']
})
export class ApplicationFamilyCreateComponent implements OnInit {
  loading = false;
  notification = {};
  states: any = [];
  ChildLeavingWith: any = [];
  companies: any = [];
  guardian : StudentGuardiansDTO = {
    GuardianID: "",
    FamilyID: "",
    Name: "",
    Surname: "",
    CompanyId: "",
    PhoneNumber: "",
    RelationshipWithChild: "",
    PrimaryGuardian: false,
    HomeAddress: "",
    City: "",
    State: "",
    Email: "",
    OfficeAddress: "",
    PrimaryGuardianLabel: "No",
    ImageType: "jpeg",
    ImageUrl: 'https://www.gravatar.com/avatar/?d=mp',
    PassportData: "",
    ImageSize: 0
  };
  guardianToSave:StudentGuardiansDTO = this.guardian;
  
  url: any = null;
  studentPassport = null;
  payload: any = {
  };

  skeletonLoader = true;


  constructor(private httpClient: HttpClient, private router: Router) { }

  ngOnInit(): void {
    this.getStates();
    this.getCompanies();
  }
  getStates() {
    this.skeletonLoader = true;
    const baseUrl = `${environment.BASE_URL}/biodata/states`;
    this.httpClient.get(baseUrl).subscribe(
      (res: any) => {
        this.states = res.Data || [];
      },
      (err) => {
      }
    );
  }

  getCompanies() {
    this.skeletonLoader = true;
    const baseUrl = `${environment.BASE_URL}/applications/companies`;
    this.httpClient.get(baseUrl).subscribe(
      (res: any) => {
        this.companies = res.Data || [];
      },
      (err) => {
      }
    );
  }

  createFamilyProfile() {
    this.loading = true;
    this.notification = {};

    const baseUrl = `${environment.BASE_URL}/applications/CreateFamilyProfile`;
    this.httpClient.post(baseUrl, this.guardianToSave).subscribe(
      (res: any) => {
        if (res.Success) {
          let message = res.Data || "Family Profile created successfully!";
          this.router.navigateByUrl(`/application/login#${message.replaceAll(" ","+")}#success`);
        }
        this.loading = false;
      },
      (err) => {
        this.loading = false;
        this.notification = errorHandler(err);
      }
    );

  }
}
